module.exports = __webpack_public_path__ + "./assets/bg_home_header.png";